import React, { useMemo } from "react";
import {
  useCountriesTimeline,
  useSingleCountryTimeline,
  useSingleStateTimeline,
} from "lib/api/distancing/timeline";

import { getCountryColor} from "lib/countries";

import MobilityTimeline from "components/MobilityTimeline";

import randomColor from "randomcolor";

import { zipWith } from "ramda";
import { useAvailableCountries, useCountryData, useStateData } from "lib/config";


import { CASES_KEY } from "lib/config";

// World timeline
function WorldDistancingTimeline(props) {
  const availableCountries = useAvailableCountries();

  const { baselineStart, baselineEnd } = props;

  const { data, error } = useCountriesTimeline(baselineStart, baselineEnd);

  if (error) {
    return <div>failed to load: {error.message}</div>;
  }

  const lines = availableCountries.map(c => ({...c, color: getCountryColor(c.id)}));

  return (
    <MobilityTimeline lines={lines} showBars={true} data={data} {...props} />
  );
}

// Single country timeline
function CountryDistancingTimeline(props) {
  const { country, baselineStart, baselineEnd } = props;
  // const availableCountries = useAvailableCountries();

  const singleCountry = useCountryData(country);
  // const singleCountry = useMemo(
  //   () => availableCountries.filter(({ id }) => id === country),
  //   [country, availableCountries]
  // );

  const { data, error } = useSingleCountryTimeline(
    country,
    baselineStart,
    baselineEnd
  );

  if (error) {
    return <div>failed to load: {error.message}</div>;
  }

  const lines = [singleCountry].map(c => ({...c, color: getCountryColor(c.id)}));

  return (
    <MobilityTimeline
      lines={lines}
      showBars={true}
      data={data}
      {...props}
    />
  );
}

// Single state timeline
function StateDistancingTimeline(props) {
  const { country, state, baselineStart, baselineEnd } = props;

  const singleCountry = useCountryData(country);

  const singleState = useStateData(country, state);
  // const availableCountries = useAvailableCountries();

  // const availableStates = useAvailableStates(country);

  // const { singleCountry, singleState } = useMemo(() => {
  //   console.log(availableCountries)
  //   return {
  //     singleCountry: availableCountries.filter(({ id }) => id === country),
  //     singleState: getStatesByCountry(availableCountries, country).filter(
  //       ({ id }) => id === state
  //     ),
  //   };
  // }, [country, state, availableCountries]);

  const { data: countryData, error: countryError } = useSingleCountryTimeline(
    country,
    baselineStart,
    baselineEnd
  );

  const { data: stateData, error: stateError } = useSingleStateTimeline(
    country,
    state,
    baselineStart,
    baselineEnd
  );

  const { fullEntities, fullData } = useMemo(() => {
    if (stateData && countryData) {
      const fullData = zipWith((s, c) => {
        if (s.date !== c.date) {
          throw new Error("Timeline data error");
        }

        return {
          date: s.date,
          content: {
            country: {
              mobilityChange: c.content[country].mobilityChange,
              reportedCases: c.content[country].reportedCases,
            },
            state: {
              mobilityChange: s.content[state].mobilityChange,
            },
          },
        };
      })(stateData, countryData);

      const fullEntities = [
        {
          id: "country",
          color: getCountryColor(singleCountry.id),
          name: singleCountry.name,
          values: ["mobilityChange", CASES_KEY],
        },
        {
          id: "state",
          color: randomColor(),
          name: singleState.name,
          values: ["mobilityChange"],
        },
      ];

      return {
        fullData,
        fullEntities,
      };
    } else {
      return {};
    }
  }, [stateData, countryData, singleCountry, singleState, country, state]);

  if (countryError || stateError) {
    return (
      <div>failed to load: {countryError?.message || stateError?.message}</div>
    );
  }

  return (
    <MobilityTimeline
      lines={fullEntities}
      showBars={true}
      data={fullData}
      {...props}
    />
  );
}

export default function DistancingTimeline(props) {
  const { level, baselineDate } = props;

  if (level === "world") {
    return (
      <WorldDistancingTimeline
        {...props}
        baselineStart={baselineDate}
        baselineEnd={baselineDate}
      />
    );
  } else if (level === "country") {
    return (
      <CountryDistancingTimeline
        {...props}
        baselineStart={baselineDate}
        baselineEnd={baselineDate}
      />
    );
  } else if (level === "state" || level === "county") {
    return (
      <StateDistancingTimeline
        {...props}
        baselineStart={baselineDate}
        baselineEnd={baselineDate}
      />
    );
  }

  return <div></div>;
}
